// extracted by mini-css-extract-plugin
module.exports = {"ldsEllipsis":"Loader_ldsEllipsis__19GwD","ldsEllipsis1":"Loader_ldsEllipsis1__pytf-","ldsEllipsis2":"Loader_ldsEllipsis2__1eCOd","ldsEllipsis3":"Loader_ldsEllipsis3__1dwHA"};